import type { FieldsetHTMLAttributes, ForwardedRef } from "react";
import { forwardRef } from "react";

import { cn } from "../utils";
import { NcFieldLayout } from "./nc-field-layout";
import { NcGroup } from "./nc-group";

export interface NcFieldsetProps extends FieldsetHTMLAttributes<HTMLFieldSetElement> {
  label: string;
  description?: string;
}

export const NcFieldset = forwardRef(
  (
    { children, label, description, className, ...props }: NcFieldsetProps,
    ref: ForwardedRef<HTMLFieldSetElement>
  ) => {
    return (
      <NcGroup data-nc="NcFieldset">
        <fieldset
          ref={ref}
          className={cn(
            // Border, radius, padding, background
            "border-ui bg-ui-light rounded-md border px-4 pt-3 pb-5",
            // Disabled
            "disabled:bg-disabled-light disabled:text-disabled disabled:opacity-80",
            // Invalid
            "aria-invalid:true:border-danger",
            // Focus within
            "focus-within:border-active",
            "group",
            className
          )}
          {...props}
        >
          <legend
            className={cn(
              // Padding, margin, background, color, font
              "bg-main text-light mb-1 rounded px-2 py-1 font-bold",
              // Invalid
              "group-aria-invalid:true:bg-danger",
              // Disabled
              "group-disabled:bg-disabled group-disabled:text-disabled-light"
            )}
          >
            {label}
          </legend>
          <div className="not-empty:mb-3">
            {description && <NcFieldLayout.Description>{description}</NcFieldLayout.Description>}
          </div>
          <div className="grid gap-6">{children}</div>
        </fieldset>
      </NcGroup>
    );
  }
);
